module.exports = __webpack_public_path__ + "dbc53358ce02fda5d9e988f96fbe6011.pdf";